// extracted by mini-css-extract-plugin
export default {"root":"fQTrx3GEkrx2JsMxHdOF","removePadding":"nnuiT7EKkHY8qtabrrHi","col":"mHlc0wsAZqdU5KCW053V","transparent":"cd6DjtxoLlVy0TIakAwU","fullWidth":"r52oFoN6zQo9IOlACofm"};